// extracted by mini-css-extract-plugin
export default {"saveChangesButton":"NotificationPreferencesForm_saveChangesButton__O6YlE","smsNotifications":"NotificationPreferencesForm_smsNotifications__DnyBP"};